import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";
import 'rc-slider/assets/index.css';

const Handle = Slider.Handle;

class SignupBudgetAdvanced extends Component {

    constructor(props) {
        super(props);
        this.state = {
            channels: null,
            budget: null,
            currency: null,
        };
    };

    componentWillMount() {
        this.setState({
            channels: this.props.channels,
            budget: this.props.budget,
            currency: this.props.currency
        }, () => {
            this._updateAutoProperty();
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({budget: nextProps.budget})
    }

    _updateAutoProperty(){
        //SET AUTO PROPERTY (OFF)
        for(var key in this.state.channels) {
            if (this.state.channels[key].selected) {
                this.state.budget[key].auto = false;
            }
        }
        this.props.updateBudget(this.state.budget);
    }

    _setSpend(key, value) {
        this.state.budget[key].spend = value;
        this.setState({budget: this.state.budget}, () => {
            this.props.updateBudget(this.state.budget);
        });
    }

    _decreaseSpend(key) {
        let spend = this.state.budget[key].spend - 1;
        if ((spend - this.state.budget[key].min_budget) <= 0) {
            this._setSpend(key, this.state.budget[key].min_budget);
        } else if (this.state.budget[key].min_budget <= spend) {
            this._setSpend(key, this.state.budget[key].spend - 1);
        }
    }

    _increaseSpend(key) {
        let spend = this.state.budget[key].spend + 1;
        if (spend >= this.state.budget[key].budget) {
            this._setSpend(key, this.state.budget[key].budget_available);
        } else if (this.state.budget[key].budget >= spend) {
            this._setSpend(key, this.state.budget[key].spend + 1);
        }
    }

    _renderImpressionsPartial(key) {
        let impressions = 0;
        if (this.state.budget) {
            impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderLeadsPartial(key) {
        let clicks = 0;
        if (this.state.budget) {
            clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            budget = budget + this.state.plan.price;
            return budget;
        } else {
            return ("...");
        }
    }

    _renderConversitionBySpend(key) {
        if (key === "bing" || key === "google") {
            let budget = this.state.budget[key].conversion_constant;
            budget = budget + (this.state.budget[key].spend / this.state.budget[key].budget_cap) * 2;
            return (budget.toFixed(1));
        } else {
            let budget = this.state.budget[key].conversion_constant;
            budget = budget + (this.state.budget[key].spend / this.state.budget[key].budget);
            return (budget.toFixed(1));
        }
    }

    _renderConversitionColor(key) {
        if ((this.state.budget[key].spend) > this.state.budget[key].budget / 2) {
            return false
        } else {
            return true
        }
    }

    _renderConversitionNumberFirst(number) {
        let value = number.split(/[,.]/);
        return (value[0]);
    }

    _renderConversitionNumberSecond(number) {
        let value = number.split(/[,.]/);
        return (value[1]);
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderHandle(props) {
        const {value, dragging, index, budget, currency, title, min, max, ...restProps} = props;
        return (
            <Tooltip
                prefixCls="rc-slider-tooltip"
                overlay={value}
                visible={true}
                placement="top"
                key={index}
                arrowContent={
                    <div className={
                        cx(Styles.sliderContainerHandle,
                            {
                                [Styles.sliderContainerHandleLow]: min === max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerHandleTitle,
                                {
                                    [Styles.sliderContainerHandleTitleLow]: min === max
                                })
                        }>
                            {title}
                            {title === "facebook" && <div className={Styles.sliderContainerHandleTitleSmall}>social</div>}
                            {title === "instagram" && <div className={Styles.sliderContainerHandleTitleSmall}>social</div>}
                            {title === "google" && <div className={Styles.sliderContainerHandleTitleSmall}>search</div>}
                            {title === "bing" && <div className={Styles.sliderContainerHandleTitleSmall}>search</div>}
                        </div>
                        <div className={Styles.sliderContainerHandleValue}>
                            {value}<span className={Styles.sliderContainerHandleValueCurrency}>{currency}</span>
                        </div>
                        <div className={
                            cx(Styles.sliderContainerHandleArrow,
                                {
                                    [Styles.sliderContainerHandleArrowGrey]: min === max
                                })
                        }/>
                    </div>}
            >
                <Handle value={value} {...restProps} />
            </Tooltip>
        );
    }

    _renderText(item) {
        return langRegister.get("signup-budget", item, this.state.temp_lang);
    }

    render() {
        return (
            <div className={Styles.container}>
                {
                    this.state.channels && this.state.budget && this.state.currency &&
                    Object.keys(this.state.channels).filter((item) => {
                        return this.state.channels[item].selected
                    }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key, i) => {
                        return (
                            <div className={
                                cx(Styles.channelContainer,
                                    {
                                        [Styles.channelContainerLast]: i === Object.keys(this.state.channels).filter((item) => {
                                            return this.state.channels[item].selected
                                        }).length - 1
                                    })
                            }>
                                <div className={Styles.sliderContainer}>
                                    <div className={
                                        cx(Styles.sliderContainerMinusButton,
                                            {
                                                [Styles.sliderContainerButtonDeactivated]: this.state.budget[key].min_budget === this.state.budget[key].budget
                                            })
                                    } onClick={() => this._decreaseSpend(key)}>
                                        <img className={Styles.durationContainerValueMinusIcon}
                                             src={require("../../assets/images/minus_icon_white_small.png")}/>
                                    </div>
                                    <div className={
                                        cx(Styles.sliderContainerHandleMobile,
                                            {
                                                [Styles.sliderContainerHandleLow]: this.state.budget[key].min_budget === this.state.budget[key].budget
                                            })
                                    }>
                                        <div className={
                                            cx(Styles.sliderContainerHandleTitle,
                                                {
                                                    [Styles.sliderContainerHandleTitleLow]: this.state.budget[key].min_budget === this.state.budget[key].budget
                                                })
                                        }>
                                            {key}
                                        </div>
                                        <div className={Styles.sliderContainerHandleValue}>
                                            {this.state.budget[key].spend}<span
                                            className={Styles.sliderContainerHandleValueCurrency}>{this.state.currency}</span>
                                        </div>
                                    </div>
                                    <Slider
                                        index={1}
                                        min={this.state.budget[key].min_budget}
                                        max={this.state.budget[key].budget}
                                        value={this.state.budget[key].spend}
                                        onChange={(value) => this._setSpend(key, value)}
                                        title={key}
                                        currency={this.state.currency}
                                        handle={this._renderHandle}
                                    />
                                    <div className={Styles.sliderContainerRail}>
                                        <div className={
                                            cx(Styles.sliderContainerRailLeft,
                                                {
                                                    [Styles.sliderContainerRailLeftLow]: this.state.budget[key].budget === this.state.budget[key].min_budget
                                                })
                                        }/>
                                        <div className={
                                            cx(Styles.sliderContainerRailRight,
                                                {
                                                    [Styles.sliderContainerRailRightLow]: this.state.budget[key].budget === this.state.budget[key].min_budget
                                                })
                                        }/>
                                        {
                                            this.state.budget[key].budget === this.state.budget[key].min_budget &&
                                            <div className={Styles.sliderContainerHandleSliderLow}/>
                                        }
                                        {
                                            this.state.budget[key].budget === this.state.budget[key].min_budget &&
                                            <div className={Styles.sliderContainerLowTrafficTitle}>
                                                {this._renderText("item_36")}
                                            </div>
                                        }
                                        {
                                            this.state.budget[key].budget !== this.state.budget[key].min_budget &&
                                            <div className={Styles.sliderContainerInfoTitle}>
                                                {this._renderText("item_43")}
                                            </div>
                                        }
                                    </div>
                                    {
                                        this.state.budget[key].budget !== this.state.budget[key].min_budget &&
                                        <div className={Styles.sliderContainerLeftTitle}>
                                            {
                                                (key === "bing" || key === "google") &&
                                                <span>{this._renderText("item_30")}</span>
                                                ||
                                                <span>{this._renderText("item_31")}</span>
                                            }
                                        </div>
                                    }
                                    {
                                        this.state.budget[key].budget !== this.state.budget[key].min_budget &&
                                        <div className={Styles.sliderContainerRightTitle}>
                                            {
                                                (key === "bing" || key === "google") &&
                                                <span>{this._renderText("item_32")}</span>
                                                ||
                                                <span>{this._renderText("item_33")}</span>
                                            }
                                        </div>
                                    }
                                    <div className={
                                        cx(Styles.sliderContainerPlusButton,
                                            {
                                                [Styles.sliderContainerButtonDeactivated]: this.state.budget[key].min_budget === this.state.budget[key].budget
                                            })
                                    } onClick={() => this._increaseSpend(key)}>
                                        <img className={Styles.durationContainerValuePlusIcon}
                                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    </div>
                                </div>
                                <div className={
                                    cx(Styles.infoContainer,
                                        {
                                            [Styles.infoContainerLast]: i === Object.keys(this.state.channels).filter((item) => {
                                                return this.state.channels[item].selected
                                            }).length - 1
                                        })
                                }>
                                    <div className={Styles.infoContainerLeft}>
                                        <div className={Styles.infoContainerLeftImpressions}>
                                            <div className={Styles.infoContainerLeftImpressionsTitle}>
                                                {this._renderText("item_34")}
                                            </div>
                                            <div className={Styles.infoContainerLeftImpressionsValue}>
                                                {this._renderImpressionsPartial(key)}
                                            </div>
                                        </div>
                                        <div className={Styles.infoContainerLeftLeads}>
                                            <div className={Styles.infoContainerLeftLeadsTitle}>
                                                {this._renderText("item_35")}
                                            </div>
                                            <div className={Styles.infoContainerLeftLeadsValue}>
                                                {this._renderLeadsPartial(key)}
                                            </div>
                                        </div>
                                        <div className={Styles.infoContainerTriangle}>
                                            <div className={Styles.infoContainerTriangleInner}>
                                                <div className={
                                                    cx(Styles.infoContainerTriangleInnerValue,
                                                        {
                                                            [Styles.infoContainerTriangleInnerValueRed]: this._renderConversitionColor(key),
                                                        })
                                                }>
                                                                    <span
                                                                        className={Styles.infoContainerTriangleInnerValueSmall}>{this._renderConversitionNumberFirst(this._renderConversitionBySpend(key))},</span>
                                                    {this._renderConversitionNumberSecond(this._renderConversitionBySpend(key))}
                                                    <span
                                                        className={Styles.infoContainerTriangleInnerValueSmall}>%</span>
                                                </div>
                                                <div className={Styles.infoContainerTriangleInnerTitle}>
                                                    {this._renderText("item_37")}
                                                </div>
                                                <div className={Styles.infoContainerTriangleInnerLine}/>
                                                <div
                                                    className={Styles.infoContainerTriangleInnerSubTitle}>
                                                    {this._renderText("item_38")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.infoContainerRight}>

                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default SignupBudgetAdvanced;


// WEBPACK FOOTER //
// ./src/components/signup-budget-advanced/component.js